import { ImpersonatingUserQueryDocument as __graphqlDocument0 } from 'store/client/documents/ImpersonatingUserQueryDocument'; 

export const impersonatingUserQuery = __graphqlDocument0





;
